import { render, staticRenderFns } from "./paperShow.vue?vue&type=template&id=fec33faa&scoped=true"
import script from "./paperShow.vue?vue&type=script&lang=js"
export * from "./paperShow.vue?vue&type=script&lang=js"
import style0 from "./paperShow.vue?vue&type=style&index=0&id=fec33faa&prod&lang=less&scoped=true"
import style1 from "./paperShow.vue?vue&type=style&index=1&id=fec33faa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec33faa",
  null
  
)

export default component.exports